// src/data/quoteData-chirofirst.js

const quoteData = {
  meta: {
    title: "Chiropractic First — Modernisation Project",
    clientName: "Chiropractic First",
    url: "https://chiropracticfirst.net.au",
    date: "2025-10-01",
    quoteNumber: "Q-2025-CHF-001",
    preparedBy: "Jason Toomer",
    summary: [
"In a thriving practice, it’s important that the first point of connection with new clients represents you, your brand, and the temperament of your practice accurately.",
"The current website is slow to load, feels dated, and doesn’t reflect the standard of care you provide.",
"Our goal is to build a long-term partnership, supporting like-minded practitioners by managing their web presence so they can stay focused on what they do best: looking after the health of their clients.",
"This project will modernise your website to deliver speed, mobile-first performance, and strong search visibility, while keeping bookings available throughout the build with a dedicated holding page. Once launched, we continue to support your practice with a fully managed service — while you keep patients healthy, we keep the website healthy.",
"My recommendation would be to go with Option A. This approach will future-proof your website, give it a fresh new look and feel that reflects your practice, and, in my opinion, represents the best overall return on investment."
]
  },

  business: {
    name: "2merative",
    abn: "61775724636",
    email: "hello@2merative.com",
    phone: "0498 135 744"
  },

  options: [
    {
      label: "Short‑term tune on the existing Stacked Site (platform limits apply)",
      sections: {
        projectApproach: [
          "It’s important to understand the limits of the current setup. Simply moving the site from Stacked to another server won’t solve the speed or SEO problems, because those issues come from how the site was built in the first place.",
          "We’ll review and optimise all images to make sure they’re the right size and format, so pages load faster on phones and desktops.",
          "We’ll simplify the layout by removing unnecessary sections and modules that slow the site down.",
          "We’ll reduce the number of external tools and heavy scripts running in the background, replacing them with lighter options where possible.",
          "We’ll improve the basics of SEO, cleaning up navigation, improving page titles and descriptions, and making sure images have the right tags.",
          "Once that’s done, we’ll measure the results and share a clear report showing the improvements and what could be done next."
        ],
        oneOff: [
          { item: "One‑off performance and UX pass on Stacked Site (or new location)", cost: 1100 }
        ],
        recurring: [
          { item: "No ongoing change to hosting or platform", costMonthly: 0, costYearly: 0 }
        ],
        notes: [
          "Gains are limited. Core issues remain until we rebuild on a modern stack.",
          "No plugin or theme control on Stacked. Changes are content‑level only."
        ]
      }
    },

    {
      label: "Rebuild Option A — React brochure site (no customer admin)",
      sections: {
        projectApproach: [
          "Build a new, fast React site on Hostinger. Mobile first. 80% of patients will visit on phones.",
          "Holding page during build. Keep booking links live at chiropracticfirst.net.au.",
          "Pages: Home, About, Services, Locations, Book, Contact. Optional: Testimonials.",
          "SEO setup. Titles, meta, open graph, sitemap, robots, clean URLs.",
          "Performance. Lean CSS, deferred scripts, image optimisation, Core Web Vitals targets.",
          "Accessibility and UX. Clear calls to action. Sticky tap‑to‑call on mobile.",
          "Content migration. Reuse approved images and copy. We re‑optimise assets.",
          "Unique design. As with patient care, one size does not fit all."
        ],
        oneOff: [
          { item: "Website build (React)", cost: 3500 },
          { item: "Content migration and image re‑optimisation", cost: 400 }
        ],
        recurring: [
          { item: "Annual hosting. SSL. Backups. Monitoring", costMonthly: 0, costYearly: 110 },
          { item: "Managed service. Up to 1 hour of changes per month included", costMonthly: 0, costYearly: 0 }
        ],
        notes: [
          "Customer changes go through 2merative. No admin login is provided in this option.",
          "Fastest and simplest path if you don’t need blogging or frequent updates."
        ]
      }
    },

    {
      label: "Rebuild Option B — React frontend + WordPress admin (blogging enabled)",
      sections: {
        projectApproach: [
          "React frontend for speed and UX. WordPress backend for admin and blogging.",
          "Holding page during build. Keep booking links live at chiropracticfirst.net.au.",
          "Pages: Home, About, Services, Locations, Book, Blog, Contact.",
          "Blog capability. Publish patient education articles. This keeps clients informed and improves SEO.",
          "Structured content types for Services and Locations so updates are safe and consistent.",
          "SEO foundations. Titles, meta, open graph, sitemap, robots, schema where appropriate.",
          "Performance. Core Web Vitals targets. Image pipelines to WebP/AVIF with responsive sizes.",
          "Unique design and layout. Built for Chiropractic First, not a generic template."
        ],
        oneOff: [
          { item: "Website build (React + WordPress CMS)", cost: 5500 },
          { item: "Content migration and image re‑optimisation", cost: 600 }
        ],
        recurring: [
          { item: "Annual hosting (VPS). SSL. Backups. Monitoring", costMonthly: 0, costYearly: 240 },
          { item: "Managed service. Up to 1 hour of changes per month included", costMonthly: 0, costYearly: 0 }
        ],
        notes: [
          "Customer receives WordPress admin to post blogs and update structured content.",
          "We separate content editing from code so site speed stays high."
        ]
      }
    }
  ],

  gstRate: 0.1,

  notes: [
    "Moving the existing Stacked Site to a new server will not fix speed, SEO, or flexibility. The issues are in the platform and codebase.",
    "The Short-term tune option would not include moving to my hosted platform, any on-going costs with your current provider remain.",
    "The admin login solution in Option B can be negated by using the 1 hour of my time per month to post blogs",
    "Bookings remain available during the project via a holding page so patient access is uninterrupted.",
    "Mobile first focus. Most patients book on phones.",
    "SEO focus. Make it easy for patients to find you.",
    "Free managed service for Chiropractors. We keep the website healthy while you keep patients healthy.",
    "Personal note. Connected to Chiropractic through my two children at ACC. We stay mindful of AHPRA rules about what should and should not be advertised."
  ],

  assumptionsExclusions: [
    "Copywriting beyond light edits is not included.",
    "Quoted costs do not include annual domain name registration or renewal.",
    "Paid third‑party services or plugins are not included unless listed.",
    "New photos or stock image purchases are not included.",
    "Complex integrations outside the scope described are not included."
  ],

  warrantySupport: [
    "30 day warranty for issues related to this build after launch.",
    "Further enhancements available at $100 per hour.",
    "Managed service includes up to 1 hour of changes per month at no cost. Unused time does not roll over."
  ],

  acceptance: [
    "Valid until 2025-10-08.",
    "Payment terms. 50% on acceptance. 50% on launch."
  ]
};

export { quoteData };
export default quoteData;
